export function scrollAppMainTop() {
  document.getElementById('app-main')?.scrollTo({ top: 0, behavior: 'smooth' });
}
